enum ProcessTypeEnum {
  Production,
  Testing,
  Print,
  Picking,
  Demo
}

export default ProcessTypeEnum;
